import { AnalyticsEventActions, AnalyticsEventFeatures } from '../typings/analytics';
const getMakeAPayment = (baseStartEvent, autopayValues) => ({
    event: Object.assign(Object.assign({}, baseStartEvent), { autopay_status: autopayValues.autopayStatus })
});
const getModifyAutopay = (baseStartEvent, autopayValues, paymentFormValues, paymentOptionObj) => ({
    event: Object.assign(Object.assign({}, baseStartEvent), { current_payment_option: paymentOptionObj.payment_option, payment_method_type: paymentFormValues.paymentMethodType, payment_from: paymentFormValues.paymentFrom, autopay_status: autopayValues.autopayStatus })
});
const getCancelAutopay = (baseStartEvent, autopayValues, paymentOptionObj) => ({
    event: Object.assign(Object.assign({}, baseStartEvent), { current_payment_option: paymentOptionObj.payment_option, payment_method_type: autopayValues.paymentMethodType, payment_from: autopayValues.paymentFrom, autopay_status: autopayValues.autopayStatus })
});
function getAddPaymentMethod(baseStartEvent, allowedPaymentMethods) {
    return {
        event: Object.assign(Object.assign({}, baseStartEvent), { allowed_payment_methods: allowedPaymentMethods })
    };
}
function getManagePaymentMethod(baseStartEvent) {
    return {
        event: Object.assign({}, baseStartEvent)
    };
}
export function getStartEventCreator(autopayValues, baseEvent, paymentFormValues, paymentOptionObj, allowedPaymentMethods) {
    const baseStartEvent = Object.assign(Object.assign({}, baseEvent), { action: AnalyticsEventActions.START });
    if (baseEvent.feature === AnalyticsEventFeatures.MAKE_A_PAYMENT ||
        baseEvent.feature === AnalyticsEventFeatures.ENROLL_AUTOPAY)
        return () => getMakeAPayment(baseStartEvent, autopayValues);
    if (baseEvent.feature === AnalyticsEventFeatures.MODIFY_AUTOPAY)
        return () => getModifyAutopay(baseStartEvent, autopayValues, paymentFormValues, paymentOptionObj);
    if (baseEvent.feature === AnalyticsEventFeatures.CANCEL_AUTOPAY)
        return () => getCancelAutopay(baseStartEvent, autopayValues, paymentOptionObj);
    if (baseEvent.feature === AnalyticsEventFeatures.ADD_PAYMENT_METHOD)
        return () => getAddPaymentMethod(baseStartEvent, allowedPaymentMethods);
    if (baseEvent.feature === AnalyticsEventFeatures.MANAGE_PAYMENT_METHOD)
        return () => getManagePaymentMethod(baseStartEvent);
    return () => {
        throw new Error(`No start event object implemented for ${baseEvent.feature}`);
    };
}
